<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Логи пользователей</h3>

      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label class="form-label col-md-3">
              Дата
            </label>
            <div class="row col-md-9">
              <div class="col-md-6">
                <div class="el-input-group">
                  <label for="startDate" class="form-label col-md-2">
                    с
                  </label>
                  <div class="col-md-7">
                    <input
                        id="startDate"
                        type="date"
                        v-model="page.filter.startDate"
                        v-on:change="reloadList()"
                        class="form-control"/>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="el-input-group">
                  <label for="endDate" class="form-label col-md-2">
                    до
                  </label>
                  <div class="col-md-7">
                    <input
                        id="endDate"
                        type="date"
                        v-model="page.filter.endDate"
                        v-on:change="reloadList()"
                        class="form-control"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="trancheNumber" class="form-label col-md-3">
              Объект
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.objectEntityName"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="(entity, index) in objectEntities" :key="index" :value="entity.id">
                  {{ entity.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row col-md-9" v-if="page.filter.objectEntityName">
          <div class="el-input-group">
            <label for="objectId" class="form-label col-md-3">
              Объект ID
            </label>
            <div class="col-md-9">
              <input class="form-control" id="objectId" type="text" v-model="page.filter.objectId">
            </div>
          </div>
        </div>
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="userUuid" class="form-label col-md-3">
              Пользователь GUID
            </label>
            <div class="col-md-9">
              <input class="form-control" id="userUuid" type="text" v-model="page.filter.userUuid">
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="action" class="form-label col-md-3">
              Действие
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.action"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="(item, index) in actionList" :key="index" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="action" class="form-label col-md-3">
              ОВПО
            </label>
            <div class="col-md-9">
              <multiselect
                  v-model="page.filter.university"
                  :options="universities"
                  :searchable="true"
                  :closeOnSelect="true"
                  label="nameRu"
                  track-by="universityId"
                  :close-on-select="true"
                  :allow-empty="true"
                  placeholder="Выберите ОВПО"
                  :multiple="false"
                  :clear-on-select="true"
                  @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
                  @remove="val => {
                      page.filter.universityId = null;
                      reloadList();
                    }"
              />
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>

  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">

      <b-button variant="primary"
                @click="reloadList()">
        Найти
      </b-button>

      <b-button variant="success"
                v-if="isAdmin()"
                :disabled="items.length === 0"
                @click="onClickExportEvents()">
        Экспортировать в MS Excel
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>

      <template #head(userFullName)="data">
        <div>
          Пользователь
        </div>
      </template>

      <template #head(universityName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('universityId')"
             :class="{'ascending': page.sort.universityId === 'ASC', 'descending': page.sort.universityId === 'DESC'}">
          ОВПО
        </div>
      </template>

      <template #head(action)="data">
        <div class="sortable-container none"
             @click="onSortChanged('action')"
             :class="{'ascending': page.sort.action === 'ASC', 'descending': page.sort.action === 'DESC'}">
          Действие
        </div>
      </template>
      <template #head(objectEntityName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('objectEntityName')"
             :class="{'ascending': page.sort.objectEntityName === 'ASC', 'descending': page.sort.objectEntityName === 'DESC'}">
          Объект
        </div>
      </template>

      <template #head(objectId)="data">
        <div class="sortable-container none"
             @click="onSortChanged('objectId')"
             :class="{'ascending': page.sort.objectId === 'ASC', 'descending': page.sort.objectId === 'DESC'}">
          Объект ID
        </div>
      </template>
      <template #head(eventTime)="data">
        <div class="sortable-container none"
             @click="onSortChanged('eventTime')"
             :class="{'ascending': page.sort.eventTime === 'ASC', 'descending': page.sort.eventTime === 'DESC'}">
          Дата
        </div>
      </template>
      <template #head(detail)="data"> Описание</template>


      <template #cell(userFullName)="data">
        <a @click="onShowEditDialog(data.item)">
          {{ data.item.userFullName }}
        </a>
      </template>
      <template #cell(universityName)="data">
        <a @click="onShowEditDialog(data.item)">
          {{ data.item.universityName }}
        </a>
      </template>
      <template #cell(action)="data">
        <a @click="onShowEditDialog(data.item)">
          {{ dict.actions[data.item.action] }}
        </a>
      </template>

      <template #cell(objectEntityName)="data">
        {{ dict.objectEntities[data.item.objectEntityName] }}
      </template>

      <template #cell(objectId)="data">
        {{ data.item.objectId }}
      </template>

      <template #cell(eventTime)="data">
        <span>{{ data.item.eventTime }} </span>
      </template>
      <template #cell(detail)="data">
        <div class="detail-cell-content">{{ data.item.detail }}</div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <!-- Modal component -->
  <!--
    <b-modal v-model="showModal" title="Добавление авансирование/удержание">
      <form class="mb-4">
        <div class="mb-3">
          <label for="trancheYear" class="form-label">
            Год
          </label>
          <select v-model="dialog.itemDto.trancheYear" id="trancheYear" required
                  class="form-select">
            <option v-for="(year, index) in trancheYears" :key="index" :value="year">
              {{ year }}
            </option>
          </select>
        </div>

        <div class="mb-3">
          <label for="trancheNumber" class="form-label">
            Номер транша
          </label>
          <select v-model="dialog.itemDto.trancheNumber" id="trancheNumber"
                  class="form-select" required>
            <option v-for="(entity, index) in objectEntities" :key="index" :value="entity.id">
              {{ entity.name }}
            </option>
          </select>
        </div>

        <div class="mb-3">
          <label for="university" class="form-label">
            ВУЗ
          </label>
          <select v-model="dialog.itemDto.university" id="university"
                  class="form-select" required>
            <option v-for="university in universities" :key="university.universityId"
                    :value="university">
              {{ university.nameRu }}
            </option>
          </select>
        </div>


        <div class="mb-3">
          <label for="totalSum" class="form-label">
            Сумма авансирование/удержание
          </label>
          <input class="form-control" type="number" required
                 id="totalSum" v-model="dialog.itemDto.totalSum">
        </div>

      </form>
    </b-modal>
  -->

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import militaryStudentService from "@/services/militaryStudentService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import universityService from "@/services/universityService";
import settingsService from "@/services/settingsService";
import delegationService from "@/services/delegationService";
import xlsExportService from "@/services/xlsExportService";
import {TemplateTypeEnum} from "@/enum/TemplateTypeEnum";
import {saveAs} from "@/assets/FileSaver.min";
import advanceDeductionService from "@/services/advanceDeductionService";
import eventService from "@/services/eventService";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      setting: {
        defaultTrancheYear: null,
        defaultTrancheNumber: null
      },
      page: {
        filter: {
          action: null,
          objectEntityName: undefined,
          objectId: null,
          userUuid: null,
          universityId: null,
          startDate: null,
          endDate: null
        },
        sort: {
          eventTime: 'DESC'
        },
        partNumber: 1,
        countInPage: 20,
      },
      universities: [],
      totalCount: 0,
      fields: [
        {key: 'userFullName', label: 'Пользователь', sortable: false},
        {key: 'universityName', label: 'ОВПО', sortable: true},
        {key: 'action', label: 'Действие', sortable: true},
        {key: 'objectEntityName', label: 'Объект', sortable: true},
        {key: 'objectId', label: 'Объект ID', sortable: true},
        {key: 'eventTime', label: 'Дата', sortable: true},
        {key: 'detail', label: 'Описание', sortable: false, class: 'detail-cell'},
      ],
      items: [],
      dict: {
        actions: {},
        objectEntities: {},
      },
      dialog: {
        itemDto: {
          trancheYear: null,
          trancheNumber: null,
          university: null,
          totalSum: null
        }
      },
      actionList: [{id: null, name: 'Все'}, {id: 'CREATE', name: 'Создание'}, {
        id: 'UPDATE',
        name: 'Обновление'
      }, {id: 'DELETE', name: 'Удаление'}],
      objectEntities: []
    };
  },
  methods: {
    async init() {

      for (const item of this.actionList) {
        this.dict.actions[item.id] = item.name;
      }


      const formatDate = (date) => date.toISOString().split('T')[0]
      const endDate = new Date()
      const startDate = new Date()
      startDate.setMonth(startDate.getMonth() - 1);

      this.page.filter.startDate = formatDate(startDate);
      this.page.filter.endDate = formatDate(endDate);

      this.reloadList();
      this.initUniversities();
      this.objectEntities = await eventService.getEventObjectNames();

      for (const item of this.objectEntities) {
        this.dict.objectEntities[item.id] = item.name;
      }
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },

    async reloadList() {
      this.isLoading = true;
      const response = await eventService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },

    async onClickExportEvents() {
      this.isLoading = true;
      const response = await eventService.exportEventsXls(this.page);
      const blob = new Blob([response], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, "user-logs.xlsx");
      this.isLoading = false;
    },


    onShowEditDialog(item) {
      this.showModal = true;
      if (!item) {
        item = {}
      }
      this.dialog.itemDto = Object.assign({}, item);
    },
    isAdmin() {
      return delegationService.isAdmin() || delegationService.isAdminReadOnly();
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.detail-cell {
  width: max(350px, 20%);
  word-break: break-word;
}

.detail-cell-content {
  width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}
</style>
